var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 39,
    viewBox: "0 0 45 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4478 19.7922C39.8258 19.5228 39.8088 18.9538 39.4154 18.7075L30.4571 13.0992L5.41165 14.5047C5.0802 14.5233 4.81626 14.7902 4.79995 15.1233L4.55754 20.075C4.5543 20.1413 4.55609 20.2077 4.56292 20.2737L5.07988 25.2721C5.11413 25.6033 5.39151 25.8554 5.72305 25.8566L30.8107 25.9474L39.4478 19.7922Z",
    fill: "#DCD413"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowShip);
export default __webpack_public_path__ + "static/media/yellowShip.2507bb22ebce65f76b007f49a9d613cc.svg";
export { ForwardRef as ReactComponent };